import { render, staticRenderFns } from "./activityDetails.vue?vue&type=template&id=428ae648&scoped=true&"
import script from "./activityDetails.vue?vue&type=script&lang=js&"
export * from "./activityDetails.vue?vue&type=script&lang=js&"
import style0 from "./activityDetails.vue?vue&type=style&index=0&id=428ae648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428ae648",
  null
  
)

export default component.exports